import sismojs from './src'

export default sismojs
